import { createActionGroup, props } from '@ngrx/store';
import { FEATURE_NAME } from './pipeline-trigger-dialog.constant';

export const pipelineTriggerDialogActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'open': props<{ id: string; }>()
  }
});
